import * as React from 'react';

import * as styles from './OffersLayout.css';
import { AuctionStatusNotification } from '../../serp/components/AuctionStatusNotification';

export interface IOffersLayoutProps {
  isEmpty: boolean;
  newbuildingOffersCarousel: React.ReactNode;
  cardsWithAd: React.ReactNode;
  emptyListingBanner: React.ReactNode;
}

export const OffersLayout = React.memo<IOffersLayoutProps>(function OffersLayout({
  isEmpty,
  newbuildingOffersCarousel,
  cardsWithAd,
  emptyListingBanner,
}) {
  return (
    <div className={styles['wrapper']} data-name="Offers">
      {isEmpty && (
        <>
          {emptyListingBanner}
          {newbuildingOffersCarousel}
        </>
      )}
      <AuctionStatusNotification />
      {cardsWithAd}
    </div>
  );
});
